import axios from 'axios';
import _get from 'lodash.get';

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue) {
    const instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      withCredentials: false,
    });

    instance.interceptors.response.use(
      (response) => {
        const timeout = 8000; // время отображения уведомления

        const message = _get(response, 'data.data.message');
        if (message) {
          const text = _get(message, 'message');
          const type = _get(message, 'type');

          const notification = {
            timeout,
          };

          if (text) {
            notification.message = text;
          }

          if (type) {
            notification.color = type;
          } else {
            notification.color = 'success';
          }
        }

        // const errors = _get(response, 'data.errors');
        // if (errors && errors.length) {
        //   errors.forEach((error) => {
        //     const notification = {
        //       timeout,
        //       message: error.message,
        //       color: 'error',
        //     };
        //   });
        // }

        return response;
      },
      (error) => {
        console.log(error);

        return Promise.reject(error);
      },
    );

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = instance;
  },
};
